import { render } from "./ProGuardados.vue?vue&type=template&id=48f8ef90&scoped=true"
import script from "./ProGuardados.vue?vue&type=script&lang=js"
export * from "./ProGuardados.vue?vue&type=script&lang=js"

import "./ProGuardados.vue?vue&type=style&index=0&id=48f8ef90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48f8ef90"

export default script